import { FlareSharp } from "@mui/icons-material";
import { AdminTemplate, PaymentAndTransactionFilter } from "../../components";

export const PaymentAndTransaction = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Ödeme ve İşlem Raporları",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={false}>
      <PaymentAndTransactionFilter />
    </AdminTemplate>
  );
};
